import { Container } from "@mui/material"
import { useEffect } from "react";
import { useTimer } from "react-timer-hook"
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { setNewTimer } from "./timerSlice";

export const Timer = () => {
  const { nextChangeTime } = useAppSelector(state => state.timer);
  const dispatch = useAppDispatch();
  const {
    minutes,
    seconds,
    restart,
  } = useTimer({
    expiryTimestamp: new Date(nextChangeTime),
    onExpire: () => {
      dispatch(setNewTimer());
    },
  });

  useEffect(() => {
    restart(new Date(nextChangeTime));
  }, [nextChangeTime]);

  return <Container id={nextChangeTime}>
    <h3>Next Terror Zone: {minutes}:{seconds < 10 ? `0${seconds}` : seconds}</h3>
  </Container>
}